import { SearchSkeletonComponent } from './search-skeleton.component';

export default angular
  .module('sfMobile.components.search-skeleton', [])
  .component('sfSearchSkeleton', SearchSkeletonComponent).name;
